export default __webpack_public_path__ + "static/media/tvs-sport.83e642a5.svg";